<template>
  <div class="bulletin-container">
    <!-- 新增公告按鈕 -->
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-plus"
      @click="handleAddBulletin"
      style="margin-bottom: 15px"
    >
      新增公告
    </el-button>

    <el-tag type="success"> 圖片須為.jpg,.png,.bmp格式，限制不超過200MB</el-tag>

    <!-- 公告列表 -->
    <el-table size="mini" :data="bulletinList" border fit highlight-current-row>
      <el-table-column align="center" label="編號" width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="建立時間" prop="content" width="150">
        <template slot-scope="scope">
          <el-tag size="mini">{{ scope.row.buildDate }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="left" label="內容" prop="content" min-width="50">
        <template slot-scope="scope">
          <el-input v-model="scope.row.bulletinBoard" type="textarea" :rows="6" size="mini" />
        </template>
      </el-table-column>
      <!--
      <el-table-column align="center" label="發布時間" width="160">
        <template slot-scope="scope">
          {{ scope.row.publishTime }}
        </template>
      </el-table-column> -->

      <el-table-column align="center" label="附件" width="500">
        <template slot-scope="scope">
          <!-- 使用 FileUpload 組件 -->
          <UploadCustom
            :span="24"
            :btnStyle="'primary'"
            :ref="`uploadBoardRef_${scope.$index}`"
            :accept="'.jpg,.jpeg,.bmp,.png'"
            :payload="boardFileModel"
            :data-obj="fileObj"
            :limit-file-count="50"
            :limitText="''"
            :use-drag="false"
            :action="'TravelSettings/bulletinBoard'"
            :auto-upload="false"
            :show-file-list="true"
            :form-on-loading-parent="formLoading"
            :btn-txt="'選擇檔案'"
            :before-file-list="getBeforeFileList(scope.row)"
          />
          <!-- 檔案列表 -->
          <!-- <div v-else-if="scope.row.files && scope.row.files.length">
            <div v-for="(file, index) in scope.row.files" :key="index" class="file-item">
              <el-link type="primary" :underline="false" @click="handleDownload(file)">
                {{ file.fileName }}
              </el-link>
            </div>
          </div> -->
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
          >
            編輯
          </el-button> -->
          <el-button
            size="mini"
            type="success"
            icon="el-icon-check"
            @click="handleSave(scope.row, scope.$index)"
          >
            保存
          </el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, scope.$index)"
          >
            刪除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { saveTravelBulletinBoard, deleteTravelBulletinBoard } from '@/api/travel'

export default {
  name: 'TravelBulletinBoard',
  components: {
    UploadCustom: () => import('@/views/ita/components/fileUploadCustom.vue'),
  },
  props: {
    travelId: {
      type: Number,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {},
  data() {
    return {
      bulletinList: this.value,
      boardFileModel: { fileInfo: [], fileIDs: [] },
      fileObj: { id: 0, type: 'tourInfo', user: '' },
      formLoading: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.bulletinList = val
        // console.log(this.bulletinList)
      },
      deep: true,
    },
    bulletinList: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
  methods: {
    getUploadRef(index) {
      return this.$refs[`uploadBoardRef_${index}`]
    },
    getBeforeFileList(row) {
      // console.log(row.fileInfo)
      if (
        row.fileInfo &&
        row.fileInfo.length > 0 &&
        row.fileInfo[0].files &&
        row.fileInfo[0].files.length > 0
      ) {
        return row.fileInfo[0].files
        // return row.fileInfo[0].files.map(file => ({
        //   id: file.id,
        //   fileName: file.fileName,
        //   url: file.url,
        // }))
      }
      return []
    },
    handleAddBulletin() {
      const newBulletin = {
        id: null,
        bulletinBoard: '',
        files: [],
        fileInfo: [],
      }
      this.bulletinList.unshift(newBulletin)
    },

    handleEdit(row) {},

    async handleSave(row, index) {
      try {
        if (!row.bulletinBoard) {
          this.$message.error('內容不能為空')
          return
        }

        let payload = {
          travelId: this.travelId,
          id: row.id,
          bulletinBoard: row.bulletinBoard,
          fileIDs: [],
          fileInfo: null,
        }
        let fileRef = this.getUploadRef(index)

        let boardPayload = await fileRef.combineFileAndPayload()
        if (boardPayload) {
          payload.fileInfo = boardPayload.fileInfo
          payload.fileIDs = boardPayload.fileIDs
        }

        // API 呼叫
        const resp = await saveTravelBulletinBoard(payload)

        if (resp.success) {
          payload.fileInfo = null
          payload.fileIDs = []
        }
        this.$message.success('保存成功')
        this.$emit('on-save', row)
      } catch (error) {
        console.error(error)
        this.$message.error('保存失敗')
      }
    },

    async handleDelete(row, index) {
      try {
        await this.$confirm('確定要刪除這則公告嗎？', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        if (row.id) {
          // API 呼叫
          await deleteTravelBulletinBoard({ travelId: this.travelId, bulletinBoardID: row.id })
        }
        this.bulletinList.splice(index, 1)

        this.$message.success('刪除成功')
        this.$emit('on-delete', index)
      } catch (error) {
        console.error(error)
        if (error !== 'cancel') {
          this.$message.error('刪除失敗')
        }
      }
    },

    handleFileSuccess(response) {
      this.$emit('on-file-upload', response)
    },

    handleDownload(file) {
      // 使用 FileUpload 組件的下載方法
      this.$refs.fileUpload.downloadFile(file.id, file.fileName)
    },
  },
}
</script>

<style scoped>
.bulletin-container {
  max-height: 600px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  align-items: center;
  margin: 2px 0;
}

.file-item .el-link {
  margin-right: 5px;
}
</style>
